import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { TrustpilotService } from 'src/app/domains/sales/trustpilot/services/trustpilot.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-trustpilot-review',
  templateUrl: './trustpilot-review.component.html',
  styleUrls: ['./trustpilot-review.component.scss']
})
export class TrustpilotReviewComponent implements OnInit, OnDestroy {
  public form: UntypedFormGroup;
  public loading: boolean = false;
  private emailPattern = /^\w+([\.-]?\w+)+@\w+([\.:-]?\w+)+(\.[a-zA-Z0-9]{2,})+$/;

  constructor(
    private fb: UntypedFormBuilder,
    private trustpilotService: TrustpilotService,
    private notification: NotificationService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern(this.emailPattern)])
    });
  }

  get name() {
    return this.form && this.form.get('name');
  }

  get email() {
    return this.form && this.form.get('email');
  }

  sendRequest() {
    this.loading = true;
    this.trustpilotService
      .requestTrustpilotReview(this.form.value)
      .subscribe(
        r => {
          this.loading = false;
          this.notification.success('sales.trustpilot.success');
        }, () => {
          this.loading = false;
        }
      )
  }

  ngOnDestroy() {
  }
}
